import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=15d4b215&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=15d4b215&prod&lang=scss"
import style1 from "./actions.vue?vue&type=style&index=1&id=15d4b215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4b215",
  null
  
)

export default component.exports